import styled, { createGlobalStyle } from 'styled-components';

interface MainContainerProps {
  $backgroundColor?: string; 
}

export const GlobalStyles = createGlobalStyle<MainContainerProps>`
  body {
    background-color: ${props => props.$backgroundColor || '#ffffff'};
  }
`;

const MainContainer = styled.div<MainContainerProps>`

  background-color: ${props => props.$backgroundColor || '#ffffff'};
  width: 100%;
  max-width: 480px;
  margin: 0 auto;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  height: 100%;
  justify-content: space-between;
  body{
      background-color: ${props => props.$backgroundColor || '#ffffff'} !important;
  }

  /* em paisagem o player de vídeo precisa da tela inteira */
  @media screen and (orientation: landscape) and (max-width: 960px) {
    max-width: 100%;
    height: 100%;
  }
`
  
export default MainContainer;